import React from 'react';
import { Route, Routes } from 'react-router';

import {
  HomePage,
  NotFoundPage,
  ScenarioFormPage,
  ScenarioListPage,
  ScenarioViewPage,
  SplashPage,
} from '../pages';
import { LanguageLayout, SidebarLayout } from '../templates';

import LanguageRedirect from './LanguageRedirect';
import ProtectedRoute from './ProtectedRoute';
import SigninRedirect from './SigninRedirect';
import SignoutRedirect from './SignoutRedirect';

/**
 * Routing tree.
 * @returns {React.FunctionComponent} React element that contains the component.
 */
function Routing() {
  return (
    <Routes>
      <Route path="/" element={<LanguageRedirect />} />
      <Route path="/callback" element={<SigninRedirect />} />
      <Route path="/signout" element={<SignoutRedirect />} />
      <Route path="/:lng/*" element={<LanguageLayout />}>
        <Route index element={<SplashPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<SidebarLayout />}>
            <Route path="home" element={<HomePage />} />
            <Route path="scenarios" element={<ScenarioListPage />} />
            <Route path="scenarios/new" element={<ScenarioFormPage />} />
            <Route
              path="scenarios/:scenarioId"
              element={<ScenarioViewPage />}
            />
            <Route
              path="scenarios/:scenarioId/edit"
              element={<ScenarioFormPage editing />}
            />
          </Route>
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default Routing;
